import { render, staticRenderFns } from "./dashboard-rank-product-column.vue?vue&type=template&id=4850523c&scoped=true&"
import script from "./dashboard-rank-product-column.vue?vue&type=script&lang=js&"
export * from "./dashboard-rank-product-column.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-rank-product-column.vue?vue&type=style&index=0&id=4850523c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4850523c",
  null
  
)

export default component.exports